import { cn } from '@/lib/cn';
import type { AssetStatus } from '../api/ame-platform.api';

const STATUS_STYLES: Record<AssetStatus, string> = {
  ACTIVE: 'bg-green-500/10 text-green-600 dark:text-green-400',
  SOFT_DELETED: 'bg-amber-500/10 text-amber-600',
  QUARANTINED: 'bg-destructive/10 text-destructive',
  PERMANENTLY_DELETED: 'bg-muted text-muted-foreground',
};

const STATUS_LABELS: Record<AssetStatus, string> = {
  ACTIVE: 'Active',
  SOFT_DELETED: 'Soft Deleted',
  QUARANTINED: 'Quarantined',
  PERMANENTLY_DELETED: 'Purged',
};

interface AssetStatusBadgeProps {
  status: AssetStatus;
  className?: string;
}

export function AssetStatusBadge({ status, className }: AssetStatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold',
        STATUS_STYLES[status] ?? 'bg-muted text-muted-foreground',
        className,
      )}
    >
      {STATUS_LABELS[status] ?? status}
    </span>
  );
}
